module.exports = __webpack_public_path__ + "img/green.5fbbae2c.svg";